import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="group bg-background-50 border border-background-200/60 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300">
      <Link to={`/article/${article.id}`} className="block">
        <div className="relative aspect-[16/9] overflow-hidden">
          <img
            src={article.cover}
            alt={article.title}
            title={`${article.title} - 向日葵视频`}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
        </div>
      </Link>
      <div className="p-4">
        <div className="flex items-center gap-3 mb-2">
          <span className="text-xs text-accent-500 bg-accent-100 px-2 py-0.5 rounded-full">{article.category}</span>
          <span className="text-xs text-foreground-400">{article.readTime}</span>
        </div>
        <Link to={`/article/${article.id}`}>
          <h3 className="text-base font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors duration-200 mb-2">
            {article.title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed mb-3">{article.excerpt}</p>
        <div className="flex items-center justify-between pt-3 border-t border-background-100">
          <span className="text-xs text-foreground-400">{article.author}</span>
          <span className="text-xs text-foreground-400">{article.date}</span>
        </div>
      </div>
    </article>
  );
}